import { CREDIT_COMMITMENT_TYPES } from '../../CalculationId.types';
import { FIELDS } from '../../partials/Form/Form.types';
import { CreditCommitmentTypeBuilder } from './CreditCommitmentTypeBuilder';
import { CreditCommitmentLabelBuilder } from './CreditCommitmentLabelBuilder';
import { LiabilityInitialData, LiabilityFormData, DataDirector, LiabilityRequestData } from './types';
import {
  CommonType,
  CreditCard,
  MaintenancePayments,
  Other,
  StudentsLoan,
  UnsecuredLoan,
  BuyToLetMortgage,
  PensionContribution,
} from './creditCommitmentDirectors';

export const liabilityTypeDirectorFactory = (type: string): DataDirector => {
  const builder = new CreditCommitmentTypeBuilder();
  const creditCommitmentDirectorsMap = new Map<string, DataDirector>([
    [CREDIT_COMMITMENT_TYPES.CREDIT_CARD.toString(), new CreditCard(builder, new CreditCommitmentLabelBuilder())],
    [CREDIT_COMMITMENT_TYPES.UNSECURED_LOAN.toString(), new UnsecuredLoan(builder, new CreditCommitmentLabelBuilder())],
    [CREDIT_COMMITMENT_TYPES.STUDENT_LOAN.toString(), new StudentsLoan(builder, new CreditCommitmentLabelBuilder())],
    [CREDIT_COMMITMENT_TYPES.OTHER.toString(), new Other(builder, new CreditCommitmentLabelBuilder())],
    [
      CREDIT_COMMITMENT_TYPES.PENSION_CONTRIBUTION.toString(),
      new PensionContribution(builder, new CreditCommitmentLabelBuilder()),
    ],
    [
      CREDIT_COMMITMENT_TYPES.MAINTENANCE_PAYMENTS.toString(),
      new MaintenancePayments(builder, new CreditCommitmentLabelBuilder()),
    ],
    [
      CREDIT_COMMITMENT_TYPES.BUY_TO_LET_MORTGAGE.toString(),
      new BuyToLetMortgage(builder, new CreditCommitmentLabelBuilder()),
    ],
  ]);

  return creditCommitmentDirectorsMap.get(type) || new CommonType(builder, new CreditCommitmentLabelBuilder());
};

export const createLiability = (type: string = ''): LiabilityFormData => ({
  [FIELDS.LIABILITY_TYPE]: type,
  [FIELDS.LIABILITY_CREDIT_CARD_BALANCE]: 0,
  [FIELDS.LIABILITY_AMOUNT]: 0,
  [FIELDS.LIABILITY_COMMITMENT_END_DATE]: null,
  [FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES]: false,
});

export const mapLiabilityResponseItem = (data: LiabilityInitialData): LiabilityFormData => {
  return {
    [FIELDS.LIABILITY_TYPE]: data.type,
    [FIELDS.LIABILITY_CREDIT_CARD_BALANCE]: data.cardBalance,
    [FIELDS.LIABILITY_AMOUNT]: data.amount,
    [FIELDS.LIABILITY_COMMITMENT_END_DATE]: data.commitmentEnds,
    [FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES]: data.isClearedBeforeLoanCompletes,
  };
};

export const mapLiabilityFormData = (data: LiabilityFormData): LiabilityRequestData => {
  return {
    amount: data[FIELDS.LIABILITY_AMOUNT],
    type: data[FIELDS.LIABILITY_TYPE],
    cardBalance: data[FIELDS.LIABILITY_CREDIT_CARD_BALANCE],
    commitmentEnds: data[FIELDS.LIABILITY_COMMITMENT_END_DATE],
    isClearedBeforeLoanCompletes: data[FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES],
  };
};
